import PropTypes from 'prop-types';

const commonPropTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    pageTitle: PropTypes.string,
    slides: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(['link', 'figure', 'chart', 'text-figures', 'media', 'columns', 'text', 'text-figures', 'picto', 'story']).isRequired,
        layout: PropTypes.oneOf(['white', 'gold', 'blue-dark', 'grey-light', 'blue-pale']),
        align: PropTypes.oneOf(['top', 'center', 'bottom']),
      })
    ).isRequired,
    layout: PropTypes.oneOf(['white', 'gold', 'blue-dark', 'grey-light', 'blue-pale']),
    align: PropTypes.oneOf(['top', 'center', 'bottom']),
  }).isRequired,
  downloadLink: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  params: PropTypes.shape({
    slideLength: PropTypes.number.isRequired,
    slideScrollingDuration: PropTypes.number.isRequired,
    scrollingMaxDuration: PropTypes.number.isRequired,
    scenesLengths: PropTypes.arrayOf(PropTypes.number).isRequired,
    scenesAnchors: PropTypes.arrayOf(PropTypes.number).isRequired,
    timelineLength: PropTypes.number.isRequired,
    timelineEnd: PropTypes.number.isRequired,
    timelineDefaults: PropTypes.shape({
      ease: PropTypes.string.isRequired,
      duration: PropTypes.number.isRequired,
    }).isRequired,
    scrollTriggerDefaults: PropTypes.shape({
      invalidateOnRefresh: PropTypes.bool.isRequired,
      scrub: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
      start: PropTypes.string.isRequired,
    }).isRequired,
    scrollTriggerId: PropTypes.string.isRequired,
  }).isRequired,
  onSceneChange: PropTypes.func.isRequired,
};

export const scenePropTypes = {
  ...commonPropTypes,
  Scene: PropTypes.func.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  onScrollUp: PropTypes.func.isRequired,
  console: PropTypes.func.isRequired,
};

export const scenesPropTypes = {
  ...commonPropTypes,
  title: PropTypes.string.isRequired,
  mountSlides: PropTypes.func.isRequired,
};

export default { scenePropTypes, scenesPropTypes };
